import _classCallCheck from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classPrivateFieldInitSpec from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import _classPrivateFieldSet from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from "vue";
var _component = /*#__PURE__*/new WeakMap();
var _query = /*#__PURE__*/new WeakMap();
export var VueComponent = /*#__PURE__*/function () {
  function VueComponent(component) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, VueComponent);
    _classPrivateFieldInitSpec(this, _component, void 0);
    _classPrivateFieldInitSpec(this, _query, function (el) {
      if (typeof el === "string") {
        var selected = document.querySelector(el);
        if (!selected) {
          return document.createElement("div");
        }
        return selected;
      } else {
        return el;
      }
    });
    var vueInstance = Vue.extend(component);
    _classPrivateFieldSet(_component, this, new vueInstance(options));
  }
  return _createClass(VueComponent, [{
    key: "get",
    value: function get(key) {
      return _classPrivateFieldGet(_component, this)[key];
    }
  }, {
    key: "set",
    value: function set(key, value) {
      _classPrivateFieldGet(_component, this)[key] = value;
    }
  }, {
    key: "mount",
    value: function mount(el, hydrating) {
      _classPrivateFieldGet(_component, this).$mount(el, hydrating);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _classPrivateFieldGet(_component, this).$destroy();
    }
  }, {
    key: "insertTo",
    value: function insertTo(el) {
      _classPrivateFieldGet(_component, this).$mount();
      _classPrivateFieldGet(_query, this).call(this, el).appendChild(_classPrivateFieldGet(_component, this).$el);
    }
  }, {
    key: "original",
    value: function original() {
      return _classPrivateFieldGet(_component, this);
    }
  }]);
}();